import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { WorkPhaseForm } from '../models/investors';
import { PROJECT_WORK_PHASE_LABELS } from '../constants/projectConstants';

interface Props {
  nextPhase: string;
  handleForm: (form: WorkPhaseForm) => void;
}

const schema = yup
  .object({
    phase: yup.string().required(),
    started_at: yup.string().required('Requerido'),
  })
  .required();

const WorkPhaseCreateForm = ({ nextPhase, handleForm }: Props) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm<WorkPhaseForm>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset({ phase: nextPhase, started_at: '' });
  }, [nextPhase]);

  return (
    <Form role="form" onSubmit={handleSubmit(handleForm)}>
      <FormGroup>
        <label className="form-control-label">Siguiente fase</label>
        <Input
          type="text"
          value={PROJECT_WORK_PHASE_LABELS[nextPhase] ?? nextPhase}
          disabled
        />
      </FormGroup>
      <FormGroup>
        <label className="form-control-label">Fecha de inicio</label>
        <Controller
          name="started_at"
          control={control}
          render={({ field }) => (
            <Input
              className={errors.started_at?.message && 'is-invalid'}
              type="date"
              {...field}
            />
          )}
        />
        <h5 className="text-danger mt-1">{errors.started_at?.message}</h5>
      </FormGroup>
      <Button color="success">Registrar fase</Button>
    </Form>
  );
};

export default WorkPhaseCreateForm;
